export default __webpack_public_path__ + "static/media/sun-light.6abebcef.svg";